<ng-template #jurisdiction let-navigateTo="navigateTo" let-active="active">
  <li
    [ngClass]="{
      active: active,
      'inactive disabled': !active
    }"
    id="location-update"
    tabindex="0">
    <i class="icon-location header-icon" [ngClass]="{ 'active-header-icon': active }" (click)="router.navigateByUrl(navigateTo)"></i>
    <div class="location-text-box">{{ 'basic-profile.jurisdiction.juri_check' | translate }}</div>
  </li>
</ng-template>

<ng-template #technicalData let-url="navigateTo" let-active="active">
  <li
    [ngClass]="{
      active: active,
      'inactive disabled': !active
    }"
    id="location-update"
    tabindex="0">
    <i class="header-icon" [ngClass]="{ 'active-header-icon': active }" (click)="router.navigateByUrl(url)">
      <span class="icon-technical_data1"></span>
      <span class="icon-technical_data2"></span>
      <span class="icon-technical_data3"></span>
    </i>
    <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
  </li>
</ng-template>

<ng-template #personalData let-url="navigateTo" let-active="active">
  <li
    [ngClass]="{
      active: active,
      'inactive disabled': !active
    }"
    id="location-update"
    tabindex="0">
    <i class="icon-info header-icon" [ngClass]="{ 'active-header-icon': active }" (click)="router.navigateByUrl(url)"></i>
    <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
  </li>
</ng-template>

<ng-template #documents let-url="navigateTo" let-active="active">
  <li
    [ngClass]="{
      active: active,
      'inactive disabled': !active
    }"
    id="location-update"
    tabindex="0">
    <i class="icon-upload header-icon" [ngClass]="{ 'active-header-icon': active }" (click)="router.navigateByUrl(url)"></i>
    <div class="location-text-box">{{ 'app.navigation.doc_upload' | translate | uppercase }}</div>
  </li>
</ng-template>

<ng-container *ngIf="configuration && templates">
  <div class="container">
    <ul class="progressbar">
      <ng-container *ngFor="let stepConfig of configuration.steps; index as i">
        <ng-container
          [ngTemplateOutlet]="templates[stepConfig.step]"
          [ngTemplateOutletContext]="{ navigateTo: stepConfig.navigateTo, active: !disabled && currentStepIndex >= i }"></ng-container>
      </ng-container>
    </ul>
  </div>
</ng-container>
